export const FETCH_USER = 'Users/FETCH_USER';
export const FETCH_USER_SUCCESS = 'Users/FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'Users/FETCH_USER_FAILURE';

export const FETCH_USERS = 'Users/FETCH_USERS';
export const FETCH_USERS_SUCCESS = 'Users/FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'Users/FETCH_USERS_FAILURE';

export const FETCH_ASSIGNMENTS_FOR_USER = 'Users/FETCH_ASSIGNMENTS_FOR_USER';
export const FETCH_ASSIGNMENTS_FOR_USER_SUCCESS = 'Users/FETCH_ASSIGNMENTS_FOR_USER_SUCCESS';
export const FETCH_ASSIGNMENTS_FOR_USER_FAILURE = 'Users/FETCH_ASSIGNMENTS_FOR_USER_FAILURE';

export const SAVE_USER = 'Users/SAVE_USER';
export const SAVE_USER_SUCCESS = 'Users/SAVE_USER_SUCCESS';
export const SAVE_USER_FAILURE = 'Users/SAVE_USER_FAILURE';

export const UPLOAD_IMPORT_USERS = 'Users/UPLOAD_IMPORT_USERS';
export const UPLOAD_IMPORT_USERS_SUCCESS = 'Users/UPLOAD_IMPORT_USERS_SUCCESS';
export const UPLOAD_IMPORT_USERS_FAILURE = 'Users/UPLOAD_IMPORT_USERS_FAILURE';

export const REMOVE_USER = 'Users/REMOVE_USER';
export const REMOVE_USER_SUCCESS = 'Users/REMOVE_USER_SUCCESS';
export const REMOVE_USER_FAILURE = 'Users/REMOVE_USER_FAILURE';

export const UPDATE_CSV_TO_UPLOAD = 'Users/UPDATE_CSV_TO_UPLOAD';
export const UPDATE_SEARCH_TERM = 'Users/UPDATE_SEARCH_TERM';
export const UPDATE_THUMBNAIL_TO_UPLOAD = 'Users/UPDATE_THUMBNAIL_TO_UPLOAD';
export const UPDATE_USERS = 'Users/UPDATE_USERS';
export const SET_USER = 'Users/SET_USER';
export const CLEAR_USER = 'Users/CLEAR_USER';
export const EMPTY_USERS = 'Users/EMPTY_USERS';

export const INCREMENT_PAGE_NUMBER = 'Users/INCREMENT_PAGE_NUMBER';



// WEBPACK FOOTER //
// ./src/containers/UsersPage/store/users/constants.js